"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REDIS_KEYS = exports.TICKER_REFRESH_MS = exports.NEW_LISTING_WINDOW_DAYS = exports.BINANCE_WS_BASE = exports.BINANCE_REST_BASE = exports.REFRESH_TOKEN_TTL = exports.ACCESS_TOKEN_TTL = exports.INTERVAL_LABELS = exports.KLINE_INTERVALS = exports.MAX_PAGE_SIZE = exports.DEFAULT_PAGE_SIZE = exports.API_PREFIX = void 0;
exports.fearGreedLabel = fearGreedLabel;
/** API prefix shared by all AiLumix endpoints */
exports.API_PREFIX = '/api/v1';
exports.DEFAULT_PAGE_SIZE = 50;
exports.MAX_PAGE_SIZE = 200;
/** Supported kline intervals (ordered from fastest to slowest) */
exports.KLINE_INTERVALS = [
    '1m', '3m', '5m', '15m', '30m', '1h', '2h', '4h', '6h', '8h', '12h', '1d', '3d', '1w', '1M',
];
exports.INTERVAL_LABELS = {
    '1m': '1m',
    '3m': '3m',
    '5m': '5m',
    '15m': '15m',
    '30m': '30m',
    '1h': '1H',
    '2h': '2H',
    '4h': '4H',
    '6h': '6H',
    '8h': '8H',
    '12h': '12H',
    '1d': '1D',
    '3d': '3D',
    '1w': '1W',
    '1M': '1M',
};
/** Access token TTL (seconds) */
exports.ACCESS_TOKEN_TTL = 2 * 60 * 60; // 2 hours
/** Refresh token TTL (seconds) */
exports.REFRESH_TOKEN_TTL = 30 * 24 * 60 * 60; // 30 days
/** Binance REST base URL (public market data, no key required). USDⓈ-M perpetual futures. */
exports.BINANCE_REST_BASE = 'https://fapi.binance.com';
/** Binance WebSocket base URL (USDⓈ-M perpetual futures) */
exports.BINANCE_WS_BASE = 'wss://fstream.binance.com';
/** New-listing window: a symbol is "new" if onboard within this many days */
exports.NEW_LISTING_WINDOW_DAYS = 90;
/** How often the ticker snapshot refreshes from Binance REST (ms) */
exports.TICKER_REFRESH_MS = 60_000;
/** Redis key prefixes */
exports.REDIS_KEYS = {
    tickers: 'glint:tickers', // hash: symbol -> JSON MarketCoin
    tickersSorted: 'glint:tickers:sorted', // zset: symbol -> quoteVolume24h
    overview: 'glint:overview',
    kline: (symbol, interval) => `glint:kline:${symbol}:${interval}`,
    deriv: 'glint:deriv', // hash: symbol -> DerivativesSnapshot
    derivTtlMs: 30_000,
    spotTickers: 'glint:spotTickers', // hash: symbol -> JSON MarketCoin (type=spot)
    orderbook: (symbol) => `glint:ob:${symbol}`,
    trades: (symbol) => `glint:trades:${symbol}`,
};
/** Fear & Greed label thresholds */
function fearGreedLabel(value) {
    if (value <= 25)
        return 'Extreme Fear';
    if (value <= 45)
        return 'Fear';
    if (value <= 55)
        return 'Neutral';
    if (value <= 75)
        return 'Greed';
    return 'Extreme Greed';
}
